import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import AddressApi from '../server/AddressApi';

function createSuccessHandler() {
    const actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    const actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);


export default {

    getById: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.ADDRESS_INFO);
        const handleError = createErrorHandler(ActionTypes.ADDRESS_INFO_ERROR);

        return AddressApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.ADDRESS_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.ADDRESS_INFO_ERROR);

        return AddressApi.save(entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.ADDRESS_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.ADDRESS_UPDATE_ERROR);

        return AddressApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    }

};
